import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
    color: #fff;
    background: #010606;

`
const Wrapper = styled.div`
    display: grid;
    z-index: 1;
    height: 30px;
    width: 100%;
    max-width: 1100px;
    margin-right: auto;
    margin-left: auto;
    padding: 0 24px;
    justify-content: center;
`
const Text = styled.h3`
    font-weight: 300;
`

const Footer = () => {

    return (
        <Container>
            <Wrapper>
                <Text>Thank you and have a great day.</Text>
            </Wrapper>
        </Container>
    )
}


export default Footer